/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bn: NonNullable<unknown>, ip: NonNullable<unknown> }} Reset_Variables_OnInputs */



/**
* | output |
* | --- |
* | "{bn} on {ip}" |
*
* @param {Reset_Variables_OnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reset_variables_on = /** @type {((inputs: Reset_Variables_OnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Variables_OnInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`${i?.bn} on ${i?.ip}`)
	return /** @type {LocalizedString} */ (`${i?.bn} sur ${i?.ip}`)
});